import { render, staticRenderFns } from "./Cta.vue?vue&type=template&id=4f9d74ab&scoped=true"
import script from "./Cta.vue?vue&type=script&lang=js"
export * from "./Cta.vue?vue&type=script&lang=js"
import style0 from "./Cta.vue?vue&type=style&index=0&id=4f9d74ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9d74ab",
  null
  
)

export default component.exports